import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";

/**
 * Site-wide floating "Join Course" CTA button.
 * Pulsates gently to grab attention. Dismissible per session.
 * Hidden on dashboard / auth / live class routes.
 */
export default function FloatingJoinCTA() {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("floating-cta-dismissed") === "1");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  // Hide on internal app routes
  if (/^\/(dashboard|login|register|live\/|courses\/[^/]+$|webinar\/)/.test(pathname)) return null;
  if (hidden || !visible) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem("floating-cta-dismissed", "1");
    setHidden(true);
  };

  return (
    <div className="hidden md:flex fixed bottom-6 left-6 z-40 items-center" data-testid="floating-join-cta">
      <Link
        to="/courses"
        className="group relative inline-flex items-center gap-2.5 bg-[#FF0066] hover:bg-[#e6005c] text-white font-semibold text-sm rounded-full pl-5 pr-6 py-3.5 shadow-[0_12px_40px_-8px_rgba(255,0,102,0.6)] transition-all"
        style={{ fontFamily: "'Outfit', system-ui, sans-serif" }}
      >
        {/* Pulsing ring */}
        <span className="absolute inset-0 rounded-full bg-[#FF0066] opacity-50 animate-ping" style={{ animationDuration: "2.4s" }} />
        <span className="relative flex items-center gap-2.5">
          <Sparkles className="w-4 h-4" />
          <span>Join a Course</span>
          <span className="hidden lg:inline-flex items-center px-2 py-0.5 rounded-full bg-white/20 text-[10px] font-bold uppercase tracking-wider">New batch</span>
        </span>
      </Link>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        data-testid="floating-cta-dismiss"
        className="ml-1.5 w-7 h-7 rounded-full bg-black/50 hover:bg-black/70 backdrop-blur border border-white/15 flex items-center justify-center text-white/70 hover:text-white transition"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
